<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible && ready" ref="modal">     
        <div class="u-window m-share-modal" v-if="!success">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="share-text">{{ text }}</div>
                </div>

                <button class="u-btn copy" data-clipboard-action="copy" :data-clipboard-text="shareTxt" @click="copy"></button>      
            </div>         
        </div>
        
        <div class="u-window m-msg-modal" v-if="success">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <div class="dialog-text">
                        链接复制成功，快去分享给好友吧！分享成功后奖励将发放至对应账号的军师邮件中，请注意查收。
                    </div>

                    <div class="u-btn ok" @click="destroyElement"></div>
                </div>   
            </div>         
        </div>         

        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            text : '十三周年预热活动正式开启，每日分享可获得分享宝箱，点击“复制链接”进行分享！',
            shareTxt : '十三周年预热活动正式开启，每日分享可获得分享宝箱，点击“复制链接”进行分享！',
            gid : '',
            ready : false,
            success : false,
        }
    },
    created (){
        if(!this.$store.state.login){
            return this.$mslogin.open();
        }
        if(!this.$store.state.userinfo){
            this.$bind_modal();
            return this.$toast('请先选择大区');
        }

        this.render();
    },  
    methods : {
        destroyElement () {
            var _this = this;
            _this.$destroy()
            _this.$el.parentNode.removeChild(_this.$el)
        },
        copy() {
            //复制链接
            let _this = this;
            let clipboard = new _this.clipboard(".copy");
            clipboard.on('success', function () {
              //_this.$toast("复制成功");
              //_this.destroyElement();
              
              _this.success = true;
            });
            clipboard.on('error', function () {
              _this.$toast("复制失败");
            });
            //_this.destroyElement();
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.share)
            .then(res => {
                _this.shareTxt = res.data.content ? res.data.content : ('【阿斗赶集】打野队友弃我！梦三大陆逐我！甚至反补我！重生一世，今天是阿斗赶集，谁帮我砍价？' + _this.$global.domain + '?key=' + res.data.key)
                _this.ready = true;
                _this.$update_user();
            },rej => {
                _this.$toast('请稍后再试')
                _this.shareTxt = '请稍后再试';
                _this.ready = true;
            });
        },       
    },
}
</script>

<style scoped>
/* share */
.m-share-modal {
    width: 584px;
    height: 344px;
    font-size: 22px;
    color: #c03b20;
    background-image: url(~@/assets/images/utils/bg-modal-msg.png);
}

.dialog-wrapper{
    padding: 90px 38px 0;
}

.m-share-modal h6 {
    /* height: 14px; */
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 15px;
}

.m-share-modal .share-text {
    padding: 0 45px;
    word-break: break-all;
}

.m-share-modal .u-btn.copy {
    position: absolute;
    left: 50%;
    bottom: 42px;
    width: 222px;
    height: 66px;
    margin-left: -120px;
    background-image: url(~@/assets/images/utils/btn-copy.png);
}

.m-msg-modal {
    width: 504px;
    height: 304px;
    background-image: url(~@/assets/images/utils/bg-modal-smsg.png);
}

.dialog-text {
    margin-top: -30px;
    font-size: 22px;
    color: #c03b20;
    text-align: center;
    word-break: break-all;
}

.dialog-text p{
    margin-bottom: 4px;
}


.u-btn.ok {
    position: absolute;
    left: 50%;
    bottom: 42px;
    width: 222px;
    height: 66px;
    margin-left: -111px;
    background-image: url(~@/assets/images/utils/btn-ok.png);
}
</style>


// WEBPACK FOOTER //
// src/components/WebShare/shareModal.vue